import { AppThunk } from '../store';

export const setTimeCount =
  (value: any): AppThunk =>
  dispatch => {
    dispatch({
      type: 'UPDATE_TIMECOUNT',
      payload: value,
    });
  };
